import services from './../../services/service'; // Service Class
import HomeLanding from './../Home/index.vue'; // Main Footer
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
import RightSidebar from './../../components/templates/rightsidebar.vue'; 
import LeftSidebar from './../../components/templates/leftsidebar.vue'; 

let service = new services();
export default {
    name: 'Home',
    data () {
        return {
            user:{},
            notifications:{},
            notifications_alert:{},
            componentMenuBottomkey:0,
            market:{},
            market_groups:{},
            market_trending:{},
            products: {},
            product: {},
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true,
            menu_view:{},
            show_login:false,
            //
            show_feeds: [],
            show_feed_slide:'Status',
            slide_feed_width:'30%',
            count_2:0,
        }
    },
  
    components: {
        'component-landing': HomeLanding,
        'component-header': MainHeader,
        'component-sticky-header': MainHeader,
        'component-footer': MainFooter,
        'right-sidebar': RightSidebar,
        'left-sidebar': LeftSidebar,
    },
    computed: {
        total() {
          var total = 0;
          for(var i = 0; i < this.items.length; i++) {
            total += this.items[i].product_price;
          }
          return total;
        }
    },
    methods: {
        

        preset(){
            this.loading = true;
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;
                    // self.loading = false;
                    self.getNotifications();
                }else {
                    self.show_login=true;
                    // self.$router.push('login');
                    // console.log(err)
                }
            });
        },

        getNotifications(){
            let navi = this.$router;
            service.getNotifications(this, this.user.user_id).then(response => {
                if(response.body.status == 200) {
                    this.notifications = response.body.data;
                    this.notifications_alert = response.body.data_alert_total;
                    this.loading = false;

                    if(this.notifications_alert > 0){
                        //mark read notifications
                        var payload = {
                            notification_type: "user",
                            notification_user: this.user.user_id,
                            notification_user_null_ref: this.user.user_id,//hack in
                            notification_business: 0,
                        }
                        service.readNotifications(this, payload).then(response => {
                            if(response.body.status == 200) {
                            //slightly refresh page w/out reloading
                            //   this.componentMenuBottomkey++
                            }
                        }).catch((err) => {})
                    }
                }
            }).catch((err) => {})
        },

        clickNotifications(noti_id,noti_url){
            let navi = this.$router;
            service.clickNotifications(this, noti_id).then(response => {
                // if(response.body.status == 200) {
                    navi.push(noti_url)
                // }
            }).catch((err) => {navi.push(noti_url)})
        },

        setMarketRemote(){
            service.getBusinessByUserName(this, service.market_app_name).then(response => {
                if(response.body.status == 200) {
                    this.market = response.body.data; 
                    this.loading = false;
                //    this.getProducts();
                }
            }).catch((err) => {
                //maybe no connection ..load from local
               // this.setSellpointLocal(); //removed...caused slower loading
            })
            
        },

        setMarketActivities(){
            service.getMarketActivityProducts(this, service.market_app_name).then(response => {
                if(response.body.status == 200) {
                    this.market_trending = response.body.data; 
                }
            }).catch((err) => {})
        },

        setMarketGroups(){
            service.getMarketGroupsProducts(this, service.market_app_name).then(response => {
                if(response.body.status == 200) {
                    this.market_groups = response.body.data; 
                }
            }).catch((err) => {})
        },

        setMenuComponent(view,view_type,attr1,attr2){  
            var top = document.getElementById("topPanel").offsetTop;
            window.scrollTo(0, top); 

            this.menu_view = {};
            this.menu_view[view] = true;
            
        },
    
        showFeeder(){
            this.show_feeds = ["Yeah","You","Got","Me","Yeah","You","Got","Me","You","Got","You","Got"];
            let f = this.show_feeds.length;
            this.slide_feed_width = (80/f)+'%';
            let self = this;
            let count = 0;
            
            let sub = 0;
            for(let x of this.show_feeds){
                sub = (f-(f-count));
                if(count == sub){
                    //let count_2 = 0;
                    setTimeout(function(){ 
                        self.show_feed_slide = x;
                        document.getElementById("StatusCode-"+self.count_2).style.borderBottomColor = "#ff0000";
                        self.count_2++;
                    }, (5000+(count*3000))); //wait for 3sec 
                    //count++;
                }
                count++;
            }
        },

        showFeed(index,feed){
            this.show_feed_slide = feed;
            let feed_color = document.getElementById("StatusCode-"+index).style.borderBottomColor;
            if(feed_color == "#3a3939"){
                feed_color = "#ff0000";
            }else{
                feed_color = "#3a3939";
            }
        },

    },
    created: function(){
        this.menu_view["timeline"] = true;
        this.preset();
        this.setMarketRemote();
        this.setMarketGroups();
        this.setMarketActivities();
        //
        let self = this;
        setTimeout(function(){
            self.showFeeder();
        }, 3000); //wait for 3sec 
        
    }
}


// WEBPACK FOOTER //
// ./src/pages/Notifications/script.js